/*
  A video as a product card's hover image.

  When a product's second media item is a video, the card draws it in the
  place of the second photograph, with the same classes, so it fades in on
  hover exactly as the photograph would. This plays it: muted, on a loop,
  while the pointer is over the card, and pauses it when the pointer
  leaves, so the next hover carries on from where it was.

  The video ships without a source and only gets one the first time its
  card is hovered, so a collection page full of video products downloads
  nothing until someone actually points at one. Its poster frame shows
  until then.

  Hover only, which in practice means a mouse: phones and tablets have no
  hover, never show the second image, and so never load the video either.

  One listener for the whole page rather than one per card, so cards added
  later, by filtering or by a section redrawing itself, work with no
  setup. Rendered by every card that has a video, so it guards against
  running twice.
*/
(() => {
  if (window.cardVideoReady) return;
  window.cardVideoReady = true;

  const HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');

  const videoOf = (event) => {
    const card = event.target.closest('.card-wrapper');
    return card ? { card, video: card.querySelector('[data-card-video]') } : {};
  };

  document.addEventListener('pointerover', (event) => {
    if (!HOVER.matches) return;

    const { video } = videoOf(event);
    if (!video || !video.paused) return;

    if (!video.dataset.started) {
      video.dataset.started = 'true';

      const source = document.createElement('source');
      source.src = video.dataset.videoSrc;
      if (video.dataset.videoType) source.type = video.dataset.videoType;
      video.appendChild(source);
      video.load();
    }

    const playing = video.play();
    if (playing && playing.catch) playing.catch(() => {});
  });

  document.addEventListener('pointerout', (event) => {
    const { card, video } = videoOf(event);
    if (!video || video.paused) return;

    // Moving between parts of the same card is not leaving it.
    if (event.relatedTarget && card.contains(event.relatedTarget)) return;

    video.pause();
  });
})();
